import { render, staticRenderFns } from "./MyBrandMap.vue?vue&type=template&id=8fb88f50&"
import script from "./-MyBrandMap.tsx?vue&type=script&lang=js&"
export * from "./-MyBrandMap.tsx?vue&type=script&lang=js&"
import style0 from "./MyBrandMap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports